// extracted by mini-css-extract-plugin
module.exports = {"bar":"LiveProgressBar_bar__GaULi"};